import React, {Component} from 'react';
import {List, Toast,NavBar,Checkbox,Modal,DatePicker} from 'antd-mobile';
import {shuntorderlist,closeOrder,getBillView} from "../../../service/shuntService";
import enUs from 'antd-mobile/lib/date-picker-view/locale/en_US';
import './index.less';
import moment from "moment";
import {connect} from "react-redux";
const CheckboxItem = Checkbox.CheckboxItem;
const noOrder = require('../../../common/image//noOrder.png');
let date = moment(new Date()).add('year',0).format("YYYY-MM-DD");
let datev ='';
const now = new Date();
// const minDate = now - 86400000;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class CombinationBill extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal:false,
           showModal:false,
           data:[],
           dateValue:"",
           checked:[],
           billView:[],
           total:0,
           dispatch:0,//传递到发单界面，控制下面的确认发单状态，代表是城内发单
           id:''
        };
    }

    componentDidMount() {
        datev = '',
        date = moment(new Date()).add('year',0).format("YYYY-MM-DD");
        this.getShuntListData(date);
        
    }

    componentWillUnmount(){
    }

    //提示modal
    modalShow=(id)=>{
        this.setState({
            showModal:true,
            id:id
        })
    };
     //关闭接口
    delete = () =>{
        let params = {
            "token": this.props.userInfo.token,
            "data":{
                "shuntOrderCombinationId":this.state.id,
                "closeType": 1
            }
         };
         closeOrder(params)
             .then((res) => {
                 console.log(res)
                 if (res.data.code === '0000') {
                    Toast.info('关闭成功');
                    this.getShuntListData(date);
                 }
                 else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
             }).catch(function (error) {
             console.log(error);
         });
    };
    
    getShuntListData=(date)=>{
        let params = {
            token: this.props.userInfo.token,
            data:{
                "pageSize": 1000,
                "pageNum": 1,
                "dispacherType":1,
                "seeTime":date
               
            }
        };
        shuntorderlist(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    this.setState({
                    data:res.data.data.list
                    })
                    let datas = this.state.data
                    if(datas && datas.length > 0){
                        let checks = [];
                        for(let i = 0;i<datas.length;i++){
                            checks.push(false)
                        }
                        this.setState({
                            checked:checks
                        })
                    }
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
    onChange = (v,index) => {
       if(this.state.checked[index]){
            let checked = this.state.checked;
            checked[index] = false;

            this.setState({
                checked:checked
            })
       }else{
           let count = 0;
           let checked = this.state.checked;

           for(let i =0;i<checked.length;i++){
                if(checked[i]){
                    count++;
                }
            }
            if(count>=3){
                Toast.info('最多只能选择三条')
                return
            }else{
                checked[index] = !checked[index];
                    this.setState({
                        checked:checked
                    })
            }
           
        };
        let checked = this.state.checked
        let checkTrue = [];
        checked.forEach((e)=>{
           if(e){
                checkTrue.push(e)
           }
        })
        this.setState({
            total:checkTrue.length
        })
    }
    goPage=()=>{
        let checked = this.state.checked;
        let data = this.state.data;
        let billView = [];
        let billViewData = [];
        let ids = [];
        for (let i in checked){
           if(checked[i]){
               billView.push({
                orderType:data[i].orderType == "送" ? 1 : 0, 
                vicinageStation:data[i].vicinageStation,
                vicinageStationLacation:data[i].vicinageStationLacation,
                addressLocation:data[i].addressLocation,
                id:data[i].shuntOrderId
               });
               billViewData.push(
                   data[i]
               )
           } 
        }
        if(this.state.total == 0){
            Toast.info('请先选择至少1条数据！');
            return
        }else{
            let params = {
                "token":this.props.userInfo.token,
                "data":billView,
            }
                Toast.loading("正在加载",0);
                getBillView(params).then((res) => {
                      if (res.data.code === '0000') {
                          Toast.hide();
                          let data = res.data.data;
                          this.props.history.push('/billView',{data:billViewData,dispatch:this.state.dispatch,startTime:data.startTime,finalPrice:data.finalPrice})
                      }
                      else if (res.data.code === '1401') {
                        document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                      }
                      else {
                          Toast.info(res.data.msg);
                      }
                  }).catch(function (error) {
                    console.log(error);
                });
        }
    };
    dateOnChange=(value)=>{
        console.log(value)
        let dateValue = moment(new Date(value)).format("YYYY-MM-DD");
        datev = dateValue;
        this.setState({
            modal:false
        })
    }
    changeDate(){
        date = datev,
        this.getShuntListData(date);
       
    }
    render() {
        var selfProps = this.props;
        return (
            <div className="combinationBill">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => {
                            selfProps.history.refresh = false;
                            selfProps.history.stateData = selfProps.history.location.stateData; 
                            selfProps.history.goBack()
                        }
                    }></i>}
                >组合发单</NavBar>
                <div className="changeDate" onClick={() => this.setState({modal:!this.state.modal})}>
                    <div>
                        <div>日期： {date}</div><div><i className="icon iconfont icontiaozhuan"></i></div>
                    </div>
                </div>
                <div className="orderBox">
                    {
                        this.state.data.length > 0 ?
                            (this.state.data.map((res,i)=>(
                                <div className="cardBox" key={i}>
                                    <div className="hearder">
                                        <div>订单号<span>{res.shuntOrderNum}</span></div>
                                        <div  onClick={()=>this.modalShow(res.shuntOrderId)}>关闭订单</div>
                                    </div>
                                    <div className="body">
                                        <div><CheckboxItem onChange={(e) => this.onChange(e,i)} checked={this.state.checked[i]}></CheckboxItem></div>
                                        <div className="location">
                                            <div><span>{res.shiftName}</span>行程时间：{res.shiftTime}</div>
                                            {res.orderType == '送' ? <div><i className="icon iconfont icondaixiadanchufadi"></i>{res.vicinageStationName}</div> :null}
                                            <div><i className={res.orderType == '接' ? 'icon iconfont icondaixiadanchufadi' : 'icon iconfont icondaixiadanmudedi'}></i>{res.orderType == "接" ? res.startAddress : res.endAddress}</div>
                                            {res.orderType == '接' ? <div><i className="icon iconfont icondaixiadanmudedi"></i>{res.vicinageStationName}</div> :null}
                                            <div className="editAddress">
                                                <span>{res.predictTime}  ¥{res.price}</span>
                                                {res.shuntOrderType == "1" ? <button onClick={()=>this.props.history.push('shuntOrder',{orderData:res,type:0 /* 用来让分流页面判断地址用 */})}>修改地址</button> : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))):<div className="noData">
                            <img src={noOrder}/>
                            <p>没有待组合数据</p>
                         </div>
                    }
                </div>
                <div className="footerPay">
                    <div>已选订单：<span>{this.state.total}</span></div>
                    <button className="sureBtn" onClick={()=>this.goPage()}>发单预览</button>
                </div>
                <Modal
                    className="combineBillViewModal"
                    visible={this.state.showModal}
                    transparent
                    maskClosable={false}
                    footer={[{ text: '取消', onPress: () => { this.setState({showModal:!this.state.showModal}); } },{ text: '确定', onPress: () => { this.setState({showModal:!this.state.showModal});this.delete() } }]}
                >
                    <div className="modalTitle">
                        <div>是否确认关闭？</div>
                        <div>关闭订单乘客将变为不分流</div>
                    </div>
                </Modal>
                <DatePicker
                    visible={this.state.modal}
                    className="picker"
                    // locale={enUs}
                    // style={{zIndex:'999999'}}
                    onDismiss={()=>this.setState({modal:false})}
                    value={this.state.dateValue}
                    mode="date"
                    // defaultDate={new Date()}
                    // minDate={new Date()}
                    onOk={() =>this.changeDate()}
                    // minDate={minDate}
                    minDate={new Date(now - 2592000000)}
                    maxDate={new Date(+now + 5184000000)}
                    onChange={this.dateOnChange}
                > </DatePicker>
                
              
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/CityService/CombinationBill/index.js